import { getCurrentLocalization } from './handleLocalization';

const isCanadianDomain = getCurrentLocalization() === 'ca';

const rawValue = (dist) => {
  const divider = isCanadianDomain ? 1000 : 1609;
  return dist / divider;
};

export function decimalDistanceToLocal(dist, metricsConfig) {
  const locale = getCurrentLocalization();
  const val = Math.round(rawValue(dist) * 100) / 100;
  return `${val}${
    metricsConfig && metricsConfig[locale] ? ` ${metricsConfig[locale]}` : ''
  }`;
}

export default function distanceToLocalStr(dist, addMetrics) {
  const metrics = isCanadianDomain ? 'km' : 'miles';
  return `${Math.floor(rawValue(dist))}${addMetrics ? ` ${metrics}` : ''}`;
}
